import { Button, FormLabel, Grid, Input, MenuItem } from '@material-ui/core';
import { postStudentAchievement } from '@webapps/business';
import {
  FormikTextField,
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Row from 'components/Form/Row';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const achievementSchema = yup.object().shape({
  label: yup.string().required('Requis'),
  type: yup.string().required('Requis'),
  path: yup.string(),
  attachment: yup.string(),
});

export const TYPES = [
  {
    value: 'file',
    label: 'Fichier',
  },
  {
    value: 'link',
    label: 'Lien',
  },
];

const AddAchievement = ({ close, refetch }) => {
  const { css } = useStyles();

  const { idUser } = useAuth();

  const {
    isLoading,
    isSuccess,
    mutateAsync: mutateAchievement,
  } = useMutation(postStudentAchievement);

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      close();
      refetch();
    }
  }, [isSuccess]);

  const formik = useFormik({
    initialValues: {
      label: '',
      type: 'link',
      path: '',
      attachment: '',
    },
    validationSchema: achievementSchema,
    onSubmit: async (values) => {      
      await mutateAchievement({
        data: values,
        id: idUser,
      });
    },
  });

  return (
    <div>
      <Row>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Intitulé de la réalisation"
              name="label"
            />
          </Grid>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label={<FormattedMessage id="achievement.type" />}
              name="type"
              select
            >
              {TYPES.map(({ label, value }, index) => (
                <MenuItem key={index} value={value}>
                  {label}
                </MenuItem>
              ))}
            </FormikTextField>
          </Grid>
          <Grid item xs={12}>
            {formik.values.type === 'file' ? (
              <FormLabel>
                <Input
                  inputProps={{
                    accept: 'application/pdf',
                  }}
                  onChange={(event) => {
                    formik.setFieldValue('attachment', event.target.files[0]);
                  }}
                  type="file"
                />
              </FormLabel>
            ) : (
              <FormikTextField
                formik={formik}
                borderRadius={6}
                fullWidth
                label={<FormattedMessage id="achievement.path" />}
                name="path"
              />
            )}
            {/* <FormikTextField
              formik={formik}
              fullWidth
              label={<FormattedMessage id="achievement.path" />}
              name="path"
            /> */}
          </Grid>
        </Grid>
      </Row>
      <Row>
        <Grid container spacing={2}>
          <Grid className={css({ textAlign: 'center' })} item xs>
            <Button
              className={css({ borderRadius: '400px' })}
              color="primary"
              disabled={isLoading}
              onClick={formik.handleSubmit}
              variant="contained"
            >
              <FormattedMessage id="vitrine.btnCreate" />
            </Button>
          </Grid>
        </Grid>
      </Row>
    </div>
  );
};

AddAchievement.propTypes = {
  refetch: PropTypes.func,
  close: PropTypes.func,
};

export default AddAchievement;
